<div class="empty-state">
  <mat-icon>{{ icon }}</mat-icon>
  <p class="empty-state__title">{{ title }}</p>
  <p class="empty-state__subtitle" *ngIf="subtitle">{{ subtitle }}</p>
</div>
